import dayjs from "dayjs";
import React from "react";
import "./index.scss";

export const Footer = () => (
  <footer className="footer">
    ©{dayjs().year()} Sharif Alexandre. All Rights Reserved.
  </footer>
);
